import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-10 px-4 sm:px-6 lg:px-24" }
const _hoisted_2 = { class: "flex flex-col gap-8" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white p-5 rounded-2xl border border-gray-150 shadow-sm" }
const _hoisted_4 = { class: "flex flex-wrap gap-4 items-center justify-end" }
const _hoisted_5 = { class: "relative flex items-center gap-2" }
const _hoisted_6 = { class: "relative min-w-[180px]" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_10 = { class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_11 = { class: "group relative overflow-hidden rounded-2xl bg-white p-6 border border-gray-150 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300 flex flex-col justify-between h-44" }
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = { class: "text-2xl font-black text-gray-900 mt-2" }
const _hoisted_14 = { class: "text-xl font-extrabold text-indigo-600 mt-0.5" }
const _hoisted_15 = { class: "rounded-xl bg-indigo-50 text-indigo-600 p-3.5 group-hover:scale-110 transition-all duration-300" }
const _hoisted_16 = { class: "border-t border-gray-100 pt-3 flex items-center justify-between" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "group relative overflow-hidden rounded-2xl bg-white p-6 border border-gray-150 shadow-sm hover:shadow-md hover:border-emerald-200 transition-all duration-300 flex flex-col justify-between h-44" }
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = { class: "text-2xl font-black text-gray-900 mt-2" }
const _hoisted_21 = { class: "text-xl font-extrabold text-emerald-600 mt-0.5" }
const _hoisted_22 = { class: "rounded-xl bg-emerald-50 text-emerald-600 p-3.5 group-hover:scale-110 transition-all duration-300" }
const _hoisted_23 = { class: "border-t border-gray-100 pt-3 flex items-center justify-between" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "group relative overflow-hidden rounded-2xl bg-white p-6 border border-gray-150 shadow-sm hover:shadow-md hover:border-amber-200 transition-all duration-300 flex flex-col justify-between h-44" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-2xl font-black text-gray-900 mt-2" }
const _hoisted_28 = { class: "text-xl font-extrabold text-amber-600 mt-0.5" }
const _hoisted_29 = { class: "rounded-xl bg-amber-50 text-amber-600 p-3.5 group-hover:scale-110 transition-all duration-300" }
const _hoisted_30 = { class: "border-t border-gray-100 pt-3 flex items-center justify-between" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_33 = { class: "flow-root" }
const _hoisted_34 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_35 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_36 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" }
const _hoisted_37 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_38 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_39 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6 capitalize" }
const _hoisted_40 = { class: "whitespace-nowrap px-3 py-4 text-sm text-center text-gray-500" }
const _hoisted_41 = { class: "whitespace-nowrap px-3 py-4 text-sm text-center text-indigo-600 font-bold" }
const _hoisted_42 = { class: "relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-semibold sm:pr-6" }
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = { key: 0 }

import { ref, onMounted, computed } from 'vue'
import { isLoggedIn, handleApiError, getBackendBaseUrl, getUserToken, logout } from '@/utils/common'
import Agent from '@/composables/admin/agent'
import Loader from '@/widgets/Loader.vue'
import Notification from '@/widgets/Notification.vue'
import { NotificationType } from '@/types/index'
import router from '@/router'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'Reports',
  setup(__props) {

const auth = isLoggedIn()
const isAgencyAdmin = computed(() => auth && auth.user && auth.user.type === 'agent' && auth.user.sub_type === null)

const isLoading = ref<boolean>(true)
const isDownloading = ref<boolean>(false)
const { reportsStats } = Agent()
const baseUrl = getBackendBaseUrl()

const selectedScope = ref<string>('this_month')
const startDate = ref<string>('')
const endDate = ref<string>('')

const sales = ref<any>({ count: 0, sum: '0.00' })
const paid = ref<any>({ count: 0, sum: '0.00' })
const unpaid = ref<any>({ count: 0, sum: '0.00' })
const staffBreakdown = ref<any[]>([])

const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: '' })

const scopes = ref([
   { id: 'all_time', name: 'Lifetime' },
   { id: 'today', name: 'Today' },
   { id: 'this_week', name: 'This Week' },
   { id: 'this_month', name: 'This Month' },
   { id: 'last_month', name: 'Last Month' },
   { id: 'this_year', name: 'This Year' },
   { id: 'last_year', name: 'Last Year' },
   { id: 'custom', name: 'Custom Date Range' }
])

onMounted(async () => {
   await fetchReports()
})

const getFinalScopeString = (): string => {
   if (selectedScope.value === 'custom') {
      if (!startDate.value || !endDate.value) {
         return ''
      }
      const format = (dateStr: string) => {
         const parts = dateStr.split('-')
         return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      return `custom_${format(startDate.value)}_${format(endDate.value)}`
   }
   return selectedScope.value
}

const fetchReports = async () => {
   const finalScope = getFinalScopeString()
   if (finalScope === '') {
      // Missing custom range date input
      return
   }

   isLoading.value = true
   const response = await reportsStats(finalScope)
   isLoading.value = false

   if (response.status === 200) {
      sales.value = response.data.sales
      paid.value = response.data.paid
      unpaid.value = response.data.unpaid
      staffBreakdown.value = response.data.staff_breakdown || []
   } else if (response.response && response.response.status === 401) {
      logout(router)
   } else {
      const errorMsg = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Failed to load', messageDetails: errorMsg }
      setTimeout(() => { notifClosed() }, 5000)
   }
}

const notifClosed = () => {
   notif.value.show = false
}

const downloadCsv = async (type: string, staffId: number = 0, staffName: string = '') => {
   const finalScope = getFinalScopeString()
   if (finalScope === '') {
      notif.value = { show: true, type: 'error', message: 'Date Missing', messageDetails: 'Please select both start and end dates first.' }
      setTimeout(() => { notifClosed() }, 4000)
      return
   }

   try {
      isDownloading.value = true
      isLoading.value = true

      let url = `${baseUrl}api/agent/reports/download/${type}/${finalScope}`
      if (type === 'staff') {
         url += `?sub_agent_id=${staffId}`
      }

      const response = await axios.get(url, {
         headers: {
            'Authorization': `Bearer ${getUserToken()}`
         },
         responseType: 'blob'
      })

      let filename = `Financial_Report_${type.toUpperCase()}_${finalScope}.csv`
      if (type === 'staff') {
         filename = `Performance_Report_${staffName.replace(/\s+/g, '_')}_${finalScope}.csv`
      }

      const disposition = response.headers['content-disposition']
      if (disposition && disposition.indexOf('attachment') !== -1) {
         const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
         const matches = filenameRegex.exec(disposition)
         if (matches != null && matches[1]) { 
            filename = matches[1].replace(/['"]/g, '')
         }
      }

      const blob = new Blob([response.data], { type: 'text/csv' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Report CSV downloaded successfully' }
      setTimeout(() => { notifClosed() }, 4000)
   } catch (error) {
      notif.value = { show: true, type: 'error', message: 'Download Failed', messageDetails: 'Failed to download report. Please try again.' }
      setTimeout(() => { notifClosed() }, 5000)
      console.error(error)
   } finally {
      isDownloading.value = false
      isLoading.value = false
   }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-xl font-bold text-gray-900" }, "Financial Reports"),
            _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-1" }, "Generate sales and payment reports with direct CSV downloads")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-xs font-bold text-gray-400 whitespace-nowrap uppercase tracking-wider" }, "Date Period:", -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedScope).value = $event)),
                  onChange: fetchReports,
                  class: "w-full pl-3 pr-8 py-2 border border-gray-300 rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent appearance-none transition-all duration-300 cursor-pointer font-semibold text-gray-700"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scopes.value, (scope) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: scope.id,
                      value: scope.id
                    }, _toDisplayString(scope.name), 9, _hoisted_7))
                  }), 128))
                ], 544), [
                  [_vModelSelect, selectedScope.value]
                ]),
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-chevron-down",
                    class: "text-xs"
                  })
                ])
              ])
            ]),
            (selectedScope.value === 'custom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                    onChange: fetchReports,
                    class: "border border-gray-300 rounded-lg px-3 py-1.5 text-sm outline-none font-semibold text-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  }, null, 544), [
                    [_vModelText, startDate.value]
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-gray-400 text-sm font-semibold" }, "to", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                    onChange: fetchReports,
                    class: "border border-gray-300 rounded-lg px-3 py-1.5 text-sm outline-none font-semibold text-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  }, null, 544), [
                    [_vModelText, endDate.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs font-extrabold text-gray-400 uppercase tracking-wider" }, "Booking Sales", -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(sales.value.count) + " Bookings ", 1),
                _createElementVNode("p", _hoisted_14, " $" + _toDisplayString(Number(sales.value.sum).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-wallet",
                  class: "text-lg"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadCsv('sales'))),
                disabled: isDownloading.value,
                class: "text-xs font-extrabold text-indigo-600 hover:text-indigo-800 flex items-center gap-1 transition-colors"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-download",
                  class: "text-[10px]"
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" Download CSV Details "))
              ], 8, _hoisted_17)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs font-extrabold text-gray-400 uppercase tracking-wider" }, "Paid Bookings", -1)),
                _createElementVNode("p", _hoisted_20, _toDisplayString(paid.value.count) + " Bookings ", 1),
                _createElementVNode("p", _hoisted_21, " $" + _toDisplayString(Number(paid.value.sum).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-circle-check",
                  class: "text-lg"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (downloadCsv('paid'))),
                disabled: isDownloading.value,
                class: "text-xs font-extrabold text-emerald-600 hover:text-emerald-800 flex items-center gap-1 transition-colors"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-download",
                  class: "text-[10px]"
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" Download CSV Details "))
              ], 8, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs font-extrabold text-gray-400 uppercase tracking-wider" }, "Unpaid Bookings", -1)),
                _createElementVNode("p", _hoisted_27, _toDisplayString(unpaid.value.count) + " Bookings ", 1),
                _createElementVNode("p", _hoisted_28, " $" + _toDisplayString(Number(unpaid.value.sum).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-circle-xmark",
                  class: "text-lg"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadCsv('unpaid'))),
                disabled: isDownloading.value,
                class: "text-xs font-extrabold text-amber-600 hover:text-amber-800 flex items-center gap-1 transition-colors"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-download",
                  class: "text-[10px]"
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" Download CSV Details "))
              ], 8, _hoisted_31)
            ])
          ])
        ]),
        (isAgencyAdmin.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Staff Performance Reports"),
                _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-0.5" }, "View booking totals per staff member and download detailed CSV performance reports")
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("table", _hoisted_37, [
                        _cache[17] || (_cache[17] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            }, "Staff Member"),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                            }, "Confirmed Bookings"),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                            }, "Total Sales Value"),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "relative py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6"
                            }, "Report Download")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffBreakdown.value, (staff) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: staff.agent_id
                            }, [
                              _createElementVNode("td", _hoisted_39, _toDisplayString(staff.agent_name), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(staff.count), 1),
                              _createElementVNode("td", _hoisted_41, " $" + _toDisplayString(Number(staff.sum).toFixed(2)), 1),
                              _createElementVNode("td", _hoisted_42, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (downloadCsv('staff', staff.agent_id, staff.agent_name)),
                                  disabled: isDownloading.value,
                                  class: "text-indigo-600 hover:text-indigo-900 flex items-center gap-1 ml-auto"
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-download",
                                    class: "text-[10px]"
                                  }),
                                  _cache[15] || (_cache[15] = _createTextVNode(" Download CSV "))
                                ], 8, _hoisted_43)
                              ])
                            ]))
                          }), 128)),
                          (staffBreakdown.value && staffBreakdown.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_44, _cache[16] || (_cache[16] = [
                                _createElementVNode("td", {
                                  colspan: "4",
                                  class: "text-center whitespace-nowrap py-8 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                                }, " No staff members registered. ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"]),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"])
  ], 64))
}
}

})